import { defineMessages } from 'react-intl';

export const generationStepMessages = defineMessages({
    'loadingDialog.generationStep.analyzing': {
        id: 'loadingDialog.generationStep.analyzing',
        defaultMessage: 'Analyzing what you shared',
        description:
            'First progress step revealed while the personalized plan is being generated',
    },
    'loadingDialog.generationStep.searching': {
        id: 'loadingDialog.generationStep.searching',
        defaultMessage: 'Searching our library',
        description:
            'Second progress step revealed while the personalized plan is being generated',
    },
    'loadingDialog.generationStep.selecting': {
        id: 'loadingDialog.generationStep.selecting',
        defaultMessage: 'Selecting relevant audio or video content',
        description:
            'Third progress step revealed while the personalized plan is being generated',
    },
    'loadingDialog.generationStep.refining': {
        id: 'loadingDialog.generationStep.refining',
        defaultMessage: 'Refining top recommendations',
        description:
            'Fourth progress step revealed while the personalized plan is being generated',
    },
});

export default generationStepMessages;
